import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const  layer00404 = new TileLayer({
  title: 'Máscara 19880905',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19880905l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00404.setVisible(false);

const layer00403 = new TileLayer({
  title: 'Máscara 19880921',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19880921l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00403.setVisible(false);
  
const layer00402 = new TileLayer({
  title: 'Máscara 19881007',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19881007l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00402.setVisible(false);

const layer00401 = new TileLayer({
  title: 'Máscara 19881210',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19881210l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00401.setVisible(false);

const layer00400 = new TileLayer({
  title: 'Máscara 19890127',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19890127l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00400.setVisible(false);

const layer00399 = new TileLayer({
  title: 'Máscara 19890212',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19890212l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00399.setVisible(false);

const layer00398 = new TileLayer({
  title: 'Máscara 19890316',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19890316l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00398.setVisible(false);

const layer00397 = new TileLayer({
  title: 'Máscara 19890417',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19890417l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00397.setVisible(false);

const layer00396 = new TileLayer({
  title: 'Máscara 19890604',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19890604l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00396.setVisible(false);

const layer00395 = new TileLayer({
  title: 'Máscara 19890722',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19890722l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00395.setVisible(false);

const layer00394 = new TileLayer({
  title: 'Máscara 19890807',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19890807l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00394.setVisible(false);

export const grupoCapa01_33 = new LayerGroup({
  title: 'Ciclo Hidrológico 1988-1989',
  fold: 'close',
  layers: [layer00394, layer00395, layer00396, layer00397, layer00398, layer00399, layer00400, layer00401, layer00402, layer00403, layer00404]
});